var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.49967V10.833M10.0001 14.1663H10.0084M18.1088 14.9999L11.4421 3.33319C11.2967 3.0767 11.0859 2.86335 10.8312 2.71492C10.5765 2.56649 10.2869 2.48828 9.9921 2.48828C9.69727 2.48828 9.40773 2.56649 9.15299 2.71492C8.89826 2.86335 8.68746 3.0767 8.5421 3.33319L1.87543 14.9999C1.7285 15.2543 1.65145 15.5431 1.6521 15.837C1.65275 16.1308 1.73108 16.4192 1.87913 16.673C2.02719 16.9269 2.23972 17.137 2.49518 17.2822C2.75063 17.4274 3.03994 17.5025 3.33376 17.4999H16.6671C16.9595 17.4996 17.2467 17.4223 17.4998 17.2759C17.753 17.1295 17.9631 16.9191 18.1092 16.6658C18.2553 16.4125 18.3321 16.1252 18.3321 15.8328C18.332 15.5404 18.255 15.2531 18.1088 14.9999Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.d52fc6abb2b6a74434e1d5338d511eac.svg";
export { ForwardRef as ReactComponent };